export * from '@primeuix/themes/material/dialog';
export { default } from '@primeuix/themes/material/dialog';
